import axios from "@/utils/axiosHelper";
// 初始化数据(含授权)
export const onGetInitDataApi = params => {
    return axios(
        { url: "/cherry/game/info/init", method: "GET", params },
        { interceptResultCode: false }
    );
};

// 信息提交
export const submitInfoApi = params => {
    return axios(
        { url: "/cherry/game/info/address", method: "POST", params },
        { interceptResultCode: false }
    )
}

// 游戏免密登录
export const secretFreeLoginApi = params => {
    return axios(
        { url: "/cherry/game/info/join", method: "POST", params },
        { interceptResultCode: false }
    )
}


// WEBPACK FOOTER //
// ./src/pages/sakura/info/api.js